import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../../../../../assets/images/chat/audio-call.svg'
import _imports_1 from '../../../../../assets/images/chat/video-call.svg'
import _imports_2 from '../../../../../assets/images/chat/add-user.svg'
import _imports_3 from '../../../../../assets/images/chat/add-user-white.svg'
import _imports_4 from '../../../../../assets/images/chat/add-members.svg'
import _imports_5 from '../../../../../assets/images/chat/close.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "ms-1 ms-md-3 ps-md-1 cursor-pointer",
  title: "Start a group chat"
}
const _hoisted_7 = {
  class: "ms-1 ms-md-3 ps-md-1 cursor-pointer",
  "data-bs-toggle": "dropdown",
  title: "View and add members"
}
const _hoisted_8 = {
  key: 0,
  src: _imports_2
}
const _hoisted_9 = {
  key: 1,
  src: _imports_3
}
const _hoisted_10 = {
  id: "member-dropdown",
  class: "dropdown-menu p-0",
  "aria-labelledby": "Group-Members"
}
const _hoisted_11 = { class: "d-flex justify-content-between px-3 py-2 border-bottom" }
const _hoisted_12 = { class: "fw-semibold" }
const _hoisted_13 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center px-3 py-2"
}
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = { class: "ps-2 fw-semibold" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "current-user ps-2" }, "You", -1 /* HOISTED */)
const _hoisted_18 = { class: "d-flex align-items-center" }
const _hoisted_19 = { class: "ps-2 fw-semibold" }
const _hoisted_20 = { class: "ms-5" }
const _hoisted_21 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AvaInitials = _resolveComponent("AvaInitials")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isCallOngoing)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.callDuration), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (!_ctx.activeConversation.hasUserLeftChat)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.activeConversation.loginIds.length > 0 && !_ctx.activeConversation?.isDraftConversation)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (!_ctx.isCallOngoing)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (!_ctx.dialogOpened && _ctx.startMeeting(_ctx.ConversationRoomTypeEnum.AudioCall))),
                      class: _normalizeClass([_ctx.dialogOpened ? 'cursor-not-allowed' : 'cursor-pointer']),
                      title: "Audio Call"
                    }, _hoisted_3, 2 /* CLASS */))
                  : _createCommentVNode("v-if", true),
                (!_ctx.isCallOngoing)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass(["ms-1 ms-md-3 ps-md-1", [_ctx.dialogOpened ? 'cursor-not-allowed' : 'cursor-pointer']]),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (!_ctx.dialogOpened && _ctx.startMeeting(_ctx.ConversationRoomTypeEnum.VideoCall))),
                      title: "Video Call"
                    }, _hoisted_5, 2 /* CLASS */))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          (!_ctx.isGroupConversation)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                _createElementVNode("img", {
                  src: _imports_2,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addNewMemberDialog && _ctx.addNewMemberDialog(...args)))
                })
              ]))
            : (_ctx.isGroupConversation)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("span", _hoisted_7, [
                    (!_ctx.isCallOngoing)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                      : (_openBlock(), _createElementBlock("img", _hoisted_9))
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, "Members(" + _toDisplayString(_ctx.activeConversation.loginIds.length + 1) + ")", 1 /* TEXT */),
                      _createElementVNode("img", {
                        class: "cursor-pointer",
                        src: _imports_4,
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addNewMemberDialog && _ctx.addNewMemberDialog(...args)))
                      })
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["users-list", { 'custom-scrollbar': _ctx.userOs == 'Windows' }])
                    }, [
                      (_ctx.loggedInUserDetails)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_component_AvaInitials, {
                                classes: "ava-sm",
                                initialsType: _ctx.AvaInitialsType.Single,
                                user: _ctx.loggedInUserDetails,
                                showStatus: true
                              }, null, 8 /* PROPS */, ["initialsType", "user"]),
                              _createElementVNode("div", null, [
                                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.loggedInUserDetails.firstName) + " " + _toDisplayString(_ctx.loggedInUserDetails.lastName), 1 /* TEXT */),
                                _hoisted_16,
                                _hoisted_17
                              ])
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getMultipleUsers(_ctx.activeConversation.loginIds), (user) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: user.userId,
                          class: "d-flex justify-content-between align-items-center px-3 py-2"
                        }, [
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_AvaInitials, {
                              classes: "ava-sm",
                              initialsType: _ctx.AvaInitialsType.Single,
                              user: user,
                              showStatus: true
                            }, null, 8 /* PROPS */, ["initialsType", "user"]),
                            _createElementVNode("span", _hoisted_19, _toDisplayString(user.firstName) + " " + _toDisplayString(user.lastName), 1 /* TEXT */)
                          ]),
                          _createElementVNode("span", _hoisted_20, [
                            _withDirectives(_createElementVNode("img", {
                              onClick: ($event: any) => (_ctx.removeParticipant(user)),
                              class: "remove-btn",
                              src: _imports_5
                            }, null, 8 /* PROPS */, _hoisted_21), [
                              [_directive_tooltip, { title: `Remove`, placement: 'bottom' }]
                            ])
                          ])
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 2 /* CLASS */),
                    (_ctx.activeConversation.loginIds.length > 0 && !_ctx.activeConversation?.isDraftConversation)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "py-2 px-3 border-top cursor-pointer",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.leaveGroup && _ctx.leaveGroup(...args)))
                        }, " Leave Group "))
                      : _createCommentVNode("v-if", true)
                  ])
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    (_ctx.showJoinBtn)
      ? (_openBlock(), _createElementBlock("span", {
          key: 2,
          class: "conversation-join-meeting-btn ms-1 ms-md-3",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.joinConversationRoom()))
        }, " Join "))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}